import { SCRIPT_URL } from '../constants/environment'
import { Api } from '../utils/api'
import type { Messages } from './@types'

const api = new Api(SCRIPT_URL, 'intl')

export const fetchLang = async (lang: string) => {
  return api.get<Messages>({
    path: `${lang}.json`,
  })
}
